import React, { Component, useState } from 'react';
import { Icon } from 'semantic-ui-react';
import './styles.css';

export default class CardCursoDragNDrop extends Component {
    constructor(props) {
        super(props)
        this.state = {
            faixaOptions: [],
            curso: this.props.curso,
            faixaMenuVisible: false,
        }

        this.nodeFaixa = {};
        this.nodeInputFaixa = {};        
    }

    componentWillMount() {
        const faixaOptions = [
            ['red', 'Vermelho'],
            ['blue', 'Azul'],
            ['green', 'Verde'],
            ['orange', 'Laranja'],
            ['teal', 'Azul Piscina'],
            ['black', 'Preto'],
        ].map( color => { 
            return { 
                key: color[0], 
                text: color[1] 
            } 
        });

        this.setState({ faixaOptions });

        document.addEventListener('mousedown', this.handleFaixaClick, false);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleFaixaClick, false);
    }

    handleFaixaClick = (e) => {
        const { curso } = this.props;

        if(this.nodeFaixa[curso.id] != null) {
            const doesNodeContain = this.nodeFaixa[curso.id].contains(e.target);
            
            curso.faixa.textDisplay = doesNodeContain ? 'none' : 'block';
            curso.faixa.inputDisplay = doesNodeContain ? 'block' : 'none';
        }

        this.setState({ curso });
    }

    changeFaixaColor = (color) => {
        const { curso } = this.props;
        
        curso.faixa.color = color;

        this.setState({ curso });
    }

    changeTextFaixa = (event) => {
        const { curso } = this.props;
        const value = event.target.value;

        curso.faixa.text = value;
            
        this.setState({ curso });
    }

    changeValorCarousel = () => {
        const { curso } = this.props;
        
        curso.valor_carousel = curso.valor_carousel != 'GRATUITO' ? 'GRATUITO' : '';
            
        this.setState({ curso });
    }

    isCursoOnScreen = (cursoIndex, carouselIndex) => { 
        return (cursoIndex >= carouselIndex && cursoIndex <= carouselIndex + 3);
    }

    render(){
        const { cursoIndex, provided, snapshot, carouselIndex } = this.props;
        const { curso, faixaMenuVisible, faixaOptions } = this.state;
        
        return(  
            <div 
                className="painel-carrosseis_carousel-card" 
                {...provided.draggableProps}
                {...provided.dragHandleProps}
                ref={provided.innerRef}
                style={{
                    userSelect: 'none',
                    boxShadow: snapshot.isDragging ? '1px 1px 5px rgba(0, 0, 0, .7)' : '',
                    ...provided.draggableProps.style,
                }}
            >
                <div 
                    id="painel-carrosseis_faixa-setter"
                    onMouseEnter={ () => this.setState({ faixaMenuVisible: true })} 
                    onMouseLeave={ () => this.setState({ faixaMenuVisible: false }) } 
                    style={{ position: 'absolute', top: '0', left: '0'}}
                >
                    <a 
                        className={ 'ui '+(curso.faixa.color ? curso.faixa.color : 'grey')+' ribbon label' } 
                        ref={ node => 
                            this.nodeFaixa[curso.id] = this.isCursoOnScreen(cursoIndex, carouselIndex) ? node : null
                        } 
                        color={ curso.faixa.color ? curso.faixa.color : 'grey' } 
                        style={{ position: 'absolute', top: '-4px', left: '-14px', zIndex: '3' }}
                    >
                        <p style={{
                            display: curso.faixa.textDisplay, 
                            position: 'relative', 
                            top: '-3px', 
                            margin: '0px', 
                            padding: '0px', 
                            height: '12px'
                        }}>
                            {curso.faixa.text}
                        </p>
                        <input
                            ref={ node => 
                                    this.nodeInputFaixa[curso.id] = this.isCursoOnScreen(cursoIndex, carouselIndex) ? node : null
                                }
                            type='text' 
                            style={{
                                width: '100px',
                                border: 'none',
                                backgroundColor: 'rgba(0,0,0, .2)',
                                color: 'black',
                                fontWeight: 600,
                                fontFamily: 'Montserrat',
                                display: curso.faixa.inputDisplay
                            }}
                            onChange = {(e) => this.changeTextFaixa(e)}
                            value = { curso.faixa.text }
                        />
                    </a>
                    <div id={curso.id+'-card-label'} style={{
                        backgroundColor: 'rgba(240, 240, 240)',
                        height: faixaMenuVisible ? '130px' : '0px',
                        opacity: faixaMenuVisible ? '1' : '0',
                        border: faixaMenuVisible ? '1px solid rgba(15, 15, 15, .3)' : 'none',
                        width: '100px',
                        position: 'absolute',
                        top: '30px',
                        left: '5px',
                        zIndex: '1',
                        borderRadius: '5px',
                        overflow: 'hidden',
                        transition: 'height .15s ease-in-out, opacity .15s ease-in-out'
                    }}>
                        <h5 style={{marginTop: '5px', marginBottom: '5px', marginLeft: '5px'}}>Cor da Faixa</h5>
                        {faixaOptions.map( option => 
                            <div 
                                id={option.key} 
                                key={option.key}
                                onClick={() => this.changeFaixaColor(option.key)} 
                                className="painel-carrosseis_card-option-faixa"
                                style={{
                                    height: '16px',
                                    fontSize: '12px',
                                    fontWeight: '500',
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    cursor: 'pointer'
                                }}
                            >
                                <p style={{marginLeft: '6px', padding: 0}}>
                                    {option.text}
                                </p> 
                                <Icon color={option.key} name="circle" />
                            </div>
                        )}
                    </div>
                </div>

                <div onClick={() => this.props.removeCurso(curso.id)}className="painel-carrosseis_carousel-close-card">
                    <Icon name="x" style={{margin: 'auto'}}></Icon>
                </div>
                
                <img 
                    src={"https://files.voitto.com.br/cursos/small/"+curso.url_amigavel+".jpg"} 
                    style={{width: "235px", borderTopLeftRadius: '10px',  borderTopRightRadius: '10px', maxHeight: '135px' }} 
                    onError={(e) => { e.target.src = e.target.src.replace('.jpg', '.png') }}
                />
                <p style={{textAlign: 'center', color: 'rgba(0, 0, 0, .87)', marginTop: '15px', fontWeight: '600'}}>
                    {curso.text}
                </p>       
                <div 
                    id={curso.id+'-card'} 
                    onClick={() => this.changeValorCarousel()} 
                    className="painel-carrosseis_card-value-text" 
                    style={{
                        position: 'absolute', 
                        left: '40px', 
                        bottom: '25px', 
                        textAlign: 'center', 
                        fontWeight: '700', 
                        width: '160px', 
                        paddingTop: '5px', 
                        paddingBottom: '5px',
                        borderRadius: '3px',
                        color: 'rgba(15, 15, 15, .87)',
                        cursor: 'pointer'
                    }}
                >
                    {curso.valor_carousel !== '' ? curso.valor_carousel : 'VALOR DO CURSO'}
                </div>
            </div>
            
        );
    }
}